import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    menuIconWrapper: {
      width: 34,
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
    menuIconButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#E1E3DD',
      borderRadius: '50%',
      width: 24,
      height: 24,
      cursor: 'pointer',
      fontSize: 1,
      color: theme.palette.secondary.main,

      '&:disabled': {
        border: '1px solid #D4D4D4',
        cursor: 'not-allowed',
      },
    },
    menuPaper: {
      borderRadius: 5,
      backgroundColor: '#fff',
      marginTop: '0.5rem',
      '& .MuiMenu-list': {
        padding: '0px',
      },
    },
    menuMain: {
      padding: 0,
    },
    menuItem: {
      fontSize: '1.4rem',
      padding: '8px 12px',
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
    },
  }),
)
